module.exports = __webpack_public_path__ + "img/fan02.deb0b516.png";